import { UI, HStack, VStack } from '@genial/components';
import { BoxBorder, Color, Spacing, Typography } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import { Box, Button } from 'native-base';
import React from 'react';
import { FlatList } from 'react-native';

import { ProductFieldProps } from '../../../../constants';
import { AssetCardInfo } from '../AssetCardInfo';

export interface AssetPrincipalCardProps<T> {
  columns: number;
  rows: number;
  item: T;
  principalInfo: keyof T;
  infos: ProductFieldProps<T>[];
  customHeaderButton?: React.ReactNode;
  customRecommendedPortfolioBadge?: React.ReactNode;
  onPress?: () => void;
}

export const AssetPrincipalCard = <T,>({
  infos,
  item,
  principalInfo,
  columns,
  rows,
  onPress,
  customHeaderButton,
  customRecommendedPortfolioBadge,
}: AssetPrincipalCardProps<T>) => {
  return (
    <UI.Shadow level={1} borderRadius={BoxBorder.heavy} p="inset.sm">
      <VStack space="stack.xxxs">
        <HStack justifyContent="space-between" space="inline.quarck">
          <UI.Text fontSize={Typography['fontsize.lg']} variant="semibold">
            {`${item[principalInfo]}`}
          </UI.Text>
          {customRecommendedPortfolioBadge}
          {customHeaderButton}
        </HStack>
        <Box w="full" h="1px" bgColor={Color['neutral.lightest']} />
        <FlatList
          key="mobile-asset-principal-card-flat-list"
          style={{ overflow: 'visible' }}
          columnWrapperStyle={{
            justifyContent: rows === 1 ? 'space-between' : undefined,
            paddingVertical: Utils.Token.ToInt(Spacing, 'stack.nano'),
          }}
          keyExtractor={(info) => info.key as string}
          data={infos}
          renderItem={({ item: info }) => (
            <AssetCardInfo columns={columns} item={item} info={info} rows={rows} />
          )}
          numColumns={columns}
        />
        {!!onPress && (
          <Button
            p={0}
            alignSelf="flex-end"
            onPress={onPress}
            variant="textLink"
            _text={{
              textTransform: 'uppercase',
              color: 'brand.tertiary.principal',
              fontFamily: Typography['fontfamily.base.semibold'],
            }}
            rightIcon={
              <UI.Icon name="ArrowRight" color={Color['brand.tertiary.principal']} size="xxs" />
            }>
            mais detalhes
          </Button>
        )}
      </VStack>
    </UI.Shadow>
  );
};
